import { render, staticRenderFns } from "./Nuevo.vue?vue&type=template&id=1b739506"
import script from "./Nuevo.vue?vue&type=script&lang=js"
export * from "./Nuevo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports